// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"882ac0bb","703":"48444ef3"}[chunkId] + ".chunk.js";
};